// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UFBsbxNF","wrapperPreview":"zSLyLICC","wrapperRecap":"bkEZU7mx","wrapperClickable":"rp1GUUD8","label":"BN4hUpMY","labelPreview":"MQHzr_ga","labelRecap":"Sb8jpwvw"};